import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Total from './Total';
import HostEarnings from './HostEarnings';
import SecurityDeposit from './SecurityDeposit';
import ServiceFee from './ServiceFee';
import SubTotal from './SubTotal';
import Discount from './Discount';

import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const InquiryDetails = (props) => {

    const { getInquiry, userType } = props;

    const hostEarnings = Number(getInquiry?.total) - Number(getInquiry?.hostServiceFee) - Number(getInquiry?.discount) - Number(getInquiry?.securityDeposit) - Number(getInquiry?.guestServiceFee);

    return (
        <div className={cx(s.cancelDetailsContainer)}>
            <div>
                <hr className={s.billingLine} />
                <h4 className={cx(s.space3, s.marginTop0, s.tripDetails)}>
                    <span><FormattedMessage {...messages.billing} /></span>
                </h4>
            </div>

            <Total
                isSpecialPriceAssigned={getInquiry?.isSpecialPriceAssigned}
                averagePrice={getInquiry?.averagePrice}
                dayDifference={getInquiry?.dayDifference}
                priceForDays={getInquiry?.basePrice}
                currency={getInquiry?.currency}
            />

            {
                getInquiry?.discount > 0 &&
                <Discount
                    discount={getInquiry?.discount}
                    discountType={getInquiry?.discountType}
                    currency={getInquiry?.currency}
                />
            }

            {
                userType === 'renter' && getInquiry?.guestServiceFee > 0 &&
                <ServiceFee
                    serviceFee={getInquiry?.guestServiceFee}
                    currency={getInquiry?.currency}
                    userType={userType}
                />
            }

            {
                userType === 'owner' && getInquiry?.hostServiceFee > 0 &&
                <ServiceFee
                    serviceFee={getInquiry?.hostServiceFee}
                    currency={getInquiry?.currency}
                    userType={userType}
                />
            }

            {
                userType === 'renter' && getInquiry?.securityDeposit > 0 &&
                <SecurityDeposit
                    securityDeposit={getInquiry?.securityDeposit}
                    currency={getInquiry?.currency}
                />
            }

            <SubTotal
                total={userType === 'owner' ? getInquiry?.basePrice : getInquiry?.total}
                userType={userType}
                currency={getInquiry?.currency}
            />

            {
                userType === 'owner' &&
                <>
                    <HostEarnings
                        hostEarnings={hostEarnings}
                        currency={getInquiry?.currency}
                    />
                    {getInquiry?.securityDeposit > 0 &&
                        <SecurityDeposit
                            securityDeposit={getInquiry?.securityDeposit}
                            currency={getInquiry?.currency}
                        />
                    }
                </>

            }

        </div>
    );
}

export default withStyles(cs, s)(InquiryDetails);

